<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style lang="less">
    @import './assets/css/reset.css';
    @import 'iview/dist/styles/iview.css';
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        min-width:1100px;
    }
    .ivu-select-single{
        .ivu-select-selection{
            height: 60px !important;
            box-shadow:0 0 0 0 transparent!important;
            border:none !important;
            border-bottom:1px solid #dcdee2!important;
            border-radius:0!important;
            -moz-user-select: none;
            -webkit-user-select: none;
            -ms-user-select: none;
            .ivu-select-input{
                height: 60px !important;
                outline: none;
                &:focus{
                    outline:0!important
                }
            }

        }
    }
    .ivu-input{
        height: 60px !important;
        border:none;
        border-bottom:1px solid #dcdee2;
        box-shadow:0 0 0 0 transparent!important;
        border-radius:0!important;
        padding-left:0 !important;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
    }
    .ivu-select-item{
        text-align:left
    }
    .ivu-select-placeholder,.ivu-select-selected-value{
        height: 60px!important;
        line-height:60px!important;
        text-align:left !important;
        padding-left:0 !important;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
    }
    .ivu-select-arrow{
        right:0!important;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue